/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import Navbar from "../components/Navbar";

import "./header.css";

function Header() {
  return (
    <>
      <div class="header">
        <Navbar/>
        <div class="info">
          <h4>
            <a href="#category" style={{fontSize:"2rem"}}>Front End Developer</a>
          </h4>
          <h1>Mustafa Altaş</h1>
          <div class="meta">
            <a href="https://www.linkedin.com/in/mustafaaltas3428/" target="_b" class="author"></a>
            {" "}
            <a href="https://www.linkedin.com/in/mustafaaltas3428/" target="_b">
              Mustafa Altaş
            </a>{" "}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
